/* eslint-disable indent */
/* eslint-disable quotes */
import qs from 'qs'
import request from './request'
import store from '@/store'

// 发送请求
function fetch (method, url, data = null, headers = null) { 
    let defaultHeaders = {
        "Content-Type": "application/x-www-form-urlencoded"
    }
    const options = {
        method: method,
        url: url,
        headers: headers === "form" ? {} : Object.assign(defaultHeaders, headers)
    }
    if (method === 'get') {
        options.params = data
    } else {
        options.data = qs.stringify(data)
    }
    return request(options)
}

function uploadFile (method, url, data = null, headers = null,obj) { 
  // let defaultHeaders = {
  //     "Content-Type": "multipart/form-data;boundary="+new Date().getTime()
  // }
  let defaultHeaders = {
      "Content-Type": "multipart/form-data;"
  }
  let options = {
      method: method,
      url: url,
      timeout: 60000,
      headers: headers === "form" ? {} : Object.assign(defaultHeaders, headers)
  }
  if(obj){
      options = Object.assign(options, obj)
  }
  options.data = data
  
  return request(options)
}

const Http = {
    get: (url, data, headers) => fetch('get', url,data, headers),
    post: (url, data, headers) => fetch('post', url, data, headers),
    upload: (url, data, headers,obj) => uploadFile('post',url, data, headers,obj)
}
export default Http